var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_277_2",
    "data-name": "Component 277 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_48_7",
    "data-name": "Component 48 \\u2013 7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3642",
    "data-name": "Rectangle 3642",
    width: 38,
    height: 38,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11475",
    "data-name": "Group 11475",
    transform: "translate(-18 -211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3654",
    "data-name": "Rectangle 3654",
    transform: "translate(27 219)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 13,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 9.5,
    height: 11.5,
    rx: 0.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11990",
    "data-name": "Path 11990",
    d: "M-1787.529,19365.238h2.388v11.568h-9.335v-2.371",
    transform: "translate(1807 -19354)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Component_48_8",
    "data-name": "Component 48 \\u2013 8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3642-2",
    "data-name": "Rectangle 3642",
    width: 38,
    height: 38,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11396",
    "data-name": "Group 11396",
    transform: "translate(-18 -211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11949",
    "data-name": "Path 11949",
    d: "M-1738.868,15496.5h5.11",
    transform: "translate(1768.771 -15271)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12029",
    "data-name": "Path 12029",
    d: "M-1738.868,15496.5h5.11",
    transform: "translate(1768.771 -15274)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12030",
    "data-name": "Path 12030",
    d: "M-1738.868,15496.5h5.11",
    transform: "translate(1768.771 -15268)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.07ecd89f8bcf864fcda933782e6cbb6b.svg";
export { ForwardRef as ReactComponent };